export default __webpack_public_path__ + "static/media/couple.e1261d53.png";